goog.provide("shadow.js.shim.module$$mui$material$Toolbar$default");
shadow.js.shim.module$$mui$material$Toolbar$default = shadow.js.shim.module$$mui$material$Toolbar.default;
